import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { ArrowRightAlt, ContactSupportOutlined } from '@material-ui/icons';
import Divider from "@material-ui/core/Divider";
import { useEffect, useState } from "react";
import { enums } from "../../enums/enums";
import { format } from "date-fns";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { ICliente } from '../../entities/catalogos/ICliente';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            '& td': {
                paddingLeft: "0"
            }
        },
        header: {
            boxSizing: "border-box",
            height: "60.52px",
            backgroundColor: "#F7F7F7",
            boxShadow: "0 2px 14px 0 rgba(0,0,0,0.08)"
        },
        mainTitle: {
            color: "#19754e",
            fontSize: "20px"
        },
        title: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "2em",
                paddingBottom: "0.2em"
            }
        },
        information: {
            color: "#212121",
            fontSize: "14px",
            fontWeight: 500
        },
        additional: {
            color: " rgba(49,49,49,0.87)",
            fontSize: "12px"
        }
    }),
);

interface StateProps {
    solicitud: Solicitud
    solicitudDestino: Solicitud
    cliente: ICliente
}

type Props = StateProps

let recoleccionConversion = {
    0: "",
    [enums.tipoRecoleccion.ocurre]: traducirLabel(288),//"Sucursal",
    [enums.tipoRecoleccion.comercial]: traducirLabel(44),//"Comercio",
    [enums.tipoRecoleccion.residencial]: traducirLabel(103),//"Domicilio",
};

const Resumen = ({ solicitud, solicitudDestino, cliente }: Props) => {
    

    const classes = useStyles();

    const [formaEnvio, setFormaEnvio] = useState("");
    const [entrega, setEntrega] = useState("");
    const [fechaRad, setFechaRad] = useState("");
    const [fechaEad, setFechaEad] = useState("");
    const [tipoSeguro, setTipoSeguro] = useState("");

    useEffect(() => {
        const tipoRecoleccionOrigenId = solicitud.tipoRecoleccionIdOrigen ? solicitud.tipoRecoleccionIdOrigen : 0;
        const tipoRecoleccionDestinoId = solicitud.tipoRecoleccionIdDestino ? solicitud.tipoRecoleccionIdDestino : 0;
        let seguro = solicitud.esSeguroBasico ? traducirLabel(273) /*"Seguro Básico"*/ : solicitud.esSeguroMercancia ? traducirLabel(274) /*"Seguro Declarado"*/ : "";

        if (solicitud.tipoRecoleccionIdOrigen !== undefined) {
            if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.ocurre){
                setFormaEnvio(traducirLabel(255)+` ${traducirLabel(288)}`);
            }
            if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.comercial){
                setFormaEnvio(traducirLabel(255)+` ${traducirLabel(44)}`);
            }
            if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.residencial){
                setFormaEnvio(traducirLabel(255)+` ${traducirLabel(103)}`);
            }
            
        }
        if (solicitud.tipoRecoleccionIdDestino !== undefined) {
            if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.ocurre){
                setEntrega(traducirLabel(115)+` ${traducirLabel(288)}`);
            }
            if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.comercial){
                setEntrega(traducirLabel(115)+` ${traducirLabel(44)}`);
            }
            if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.residencial){
                setEntrega(traducirLabel(115)+` ${traducirLabel(103)}`);
            }
        }
        let language = 'es';
        if (solicitud.id == 0) {
            let fechaCRad=solicitudDestino.fechaCitaRad ? format(solicitudDestino.fechaCitaRad, 'dd MMM yyyy h:mm a') : "";
            let fechaCEad=solicitudDestino.fechaCitaEad ? format(solicitudDestino.fechaCitaEad, 'dd MMM yyyy h:mm a') : "";
            let fechaCRadCedis=solicitudDestino.fechaCitaRadCedis ? format(solicitudDestino.fechaCitaRadCedis, 'dd MMM yyyy h:mm a') : "";
            let fechaCEadCedis=solicitudDestino.fechaCitaEadCedis ? format(solicitudDestino.fechaCitaEadCedis, 'dd MMM yyyy h:mm a') : "";
            
            if( fechaCRad !== undefined && fechaCRad !== "01 Jan 1900 12:00 AM")
                setFechaRad(solicitudDestino.fechaCitaRad ? format(solicitudDestino.fechaCitaRad, 'dd MMM yyyy h:mm a') : "");
            if( fechaCEad !== undefined && fechaCEad !== "01 Jan 1900 12:00 AM")
                setFechaEad(solicitudDestino.fechaCitaEad ? format(solicitudDestino.fechaCitaEad, 'dd MMM yyyy h:mm a') : "");
            if( fechaCRadCedis !== undefined && fechaCRadCedis !== "01 Jan 1900 12:00 AM")
                setFechaRad(solicitudDestino.fechaCitaRadCedis ? format(solicitudDestino.fechaCitaRadCedis, 'dd MMM yyyy h:mm a') : "");
            if( fechaCEadCedis !== undefined && fechaCEad !== "01 Jan 1900 12:00 AM")
                setFechaEad(solicitudDestino.fechaCitaEadCedis ? format(solicitudDestino.fechaCitaEadCedis, 'dd MMM yyyy h:mm a') : "");
        }
        else {
            setFechaRad(solicitud.fechaCitaRad ? `${new Date(solicitud.fechaCitaRad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            setFechaEad(solicitud.fechaCitaEad ? `${new Date(solicitud.fechaCitaEad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
        }
        if(localStorage.getItem("idioma")==='en-US'){
            language = 'en';
            if (solicitud.id == 0) {
                let fechaCRad=solicitudDestino.fechaCitaRad ? format(solicitudDestino.fechaCitaRad, 'MMM dd yyyy h:mm a') : "";
                let fechaCEad=solicitudDestino.fechaCitaEad ? format(solicitudDestino.fechaCitaEad, 'MMM dd yyyy h:mm a') : "";
                let fechaCRadCedis=solicitudDestino.fechaCitaRadCedis ? format(solicitudDestino.fechaCitaRadCedis, 'MMM dd yyyy h:mm a') : "";
                let fechaCEadCedis=solicitudDestino.fechaCitaEadCedis ? format(solicitudDestino.fechaCitaEadCedis, 'MMM dd yyyy h:mm a') : "";
                if( fechaCRad !== undefined && fechaCRad !== "01 Jan 1900 12:00 AM")
                    setFechaRad(solicitudDestino.fechaCitaRad ? format(solicitudDestino.fechaCitaRad, 'MMM dd yyyy h:mm a') : "");
                if( fechaCEad !== undefined && fechaCEad !== "01 Jan 1900 12:00 AM")
                    setFechaEad(solicitudDestino.fechaCitaEad ? format(solicitudDestino.fechaCitaEad, 'MMM dd yyyy h:mm a') : "");
                if( fechaCRadCedis !== undefined && fechaCRadCedis !== "01 Jan 1900 12:00 AM")
                    setFechaRad(solicitudDestino.fechaCitaRadCedis ? format(solicitudDestino.fechaCitaRadCedis, 'MMM dd yyyy h:mm a') : "");
                if( fechaCEadCedis !== undefined && fechaCEad !== "01 Jan 1900 12:00 AM")
                    setFechaEad(solicitudDestino.fechaCitaEadCedis ? format(solicitudDestino.fechaCitaEadCedis, 'MMM dd yyyy h:mm a') : "");
            }
            else {
                setFechaRad(solicitud.fechaCitaRad ? `${new Date(solicitud.fechaCitaRad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                setFechaEad(solicitud.fechaCitaEad ? `${new Date(solicitud.fechaCitaEad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            }
        }
        

        if(solicitud.esSeguroBasico){
            setTipoSeguro(traducirLabel(273));
        }
        else{
            if(solicitud.esSeguroMercancia){
                setTipoSeguro(traducirLabel(274));
            }
            else{
                setTipoSeguro('');
            }
        }
    }, [solicitud, localStorage.getItem("idioma")]);

    return (<>
        {solicitud.coloniaOrigen &&
            <Paper>
                <Box className={classes.header} display="flex" alignItems="center">
                    <Box className={classes.mainTitle} px={3}>
                        {/* Resumen */
                            traducirLabel(264)}
                    </Box>
                </Box>

                <Box px={3} pb={2}>
                    <Box display="flex" flexWrap="wrap">
                        <table className={classes.root}>
                            <tbody>
                                {cliente.grupoClienteID >= 0 && (cliente.clienteCreditoProyecto && cliente.clienteCreditoProyecto?.length >= 2) &&
                                    <tr className={classes.title}>
                                        <td style={{ width: "45%" }}>
                                            {/* PROYECTO */
                                                traducirLabel(241)}
                                        </td>
                                        <td style={{ width: "10%" }} />
                                        <td className={classes.information} style={{ width: "45%" }}>{solicitud.proyecto?.descripcion}</td>
                                    </tr>
                                }
                                <tr className={classes.title}>
                                    <td style={{ width: "45%" }}>
                                        {/* ORIGEN */
                                            traducirLabel(222)}
                                    </td>
                                    <td style={{ width: "10%" }} />
                                    <td style={{ width: "45%" }}>
                                        {/* DESTINO */
                                            traducirLabel(86)}
                                    </td>
                                </tr>
                                
                                <tr style={{ fontSize: "14px", color: "rgba(0,0,0,0.87)", fontWeight: 500 }}>
                                    <td>
                                        {solicitud.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.ocurre ?
                                            `${solicitud.sucursalOrigen?.ciudad.nombre} ${solicitud.sucursalOrigen?.estado.nombre}`
                                            : solicitud.coloniaOrigen?.direccionResumen}
                                    </td>
                                    <td><ArrowRightAlt style={{ verticalAlign: "middle" }} /></td>
                                    <td>
                                        {solicitudDestino.tipoRecoleccionIdDestino === enums.tipoRecoleccion.ocurre ?
                                            `${solicitudDestino.sucursalDestino?.ciudad.nombre} ${solicitudDestino.sucursalDestino?.estado.nombre}`
                                            : solicitudDestino.coloniaDestino?.direccionResumen}
                                    </td>
                                </tr>
                                
                                {cliente.esClase == true &&
                                    <>
                                        <tr className={classes.title}>
                                            <td>
                                                {/* Clase */
                                                    traducirLabel(34)}
                                            </td>
                                            <td />
                                            <td />
                                        </tr>

                                        <tr className={classes.information}>
                                            <td>{typeof solicitud.clase == "string" ? solicitud.clase : ''}</td>
                                            <td />
                                            <td />
                                        </tr>
                                    </>
                                }

                                {solicitud.tipoRecoleccionIdOrigen &&
                                    <>
                                        <tr className={classes.title}>
                                            <td>
                                                {/* FORMA DE ENVÍO */
                                                    traducirLabel(142)}
                                            </td>
                                            <td />
                                            <td>
                                                {/* ENTREGA */
                                                    traducirLabel(114)}
                                            </td>
                                        </tr>

                                        <tr className={classes.information}>
                                            <td>{formaEnvio}</td>
                                            <td />
                                            <td>{entrega ? entrega : ""}</td>
                                        </tr>

                                    </>
                                }

                                <tr>
                                    <td>
                                        <table>
                                            <tr className={classes.additional}>
                                                <td style={{ verticalAlign: "top" }}>
                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                        {
                                                            solicitud.tipoRecoleccionIdOrigen !== undefined
                                                            &&
                                                            solicitud.tipoRecoleccionIdOrigen !== 3
                                                            &&
                                                            fechaRad
                                                            &&
                                                            (
                                                                !solicitudDestino.EsRadCitaFueraHorario
                                                                &&
                                                                <li key={0}>
                                                                    {fechaRad.toString().substr(0, 11)}
                                                                </li>
                                                                ||
                                                                solicitudDestino.EsRadCitaFueraHorario
                                                                &&
                                                                <li>
                                                                    {fechaRad.toString().substr(0, 11) + " " + solicitud.RadCitaHoraDe + " - " + solicitud.RadCitaHoraHasta}
                                                                </li>
                                                            )

                                                        }

                                                        {localStorage.getItem("idioma")==='en-US' && solicitudDestino.serviciosAdicionalesOrigen?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                                solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA RAD' && solicitudDestino.fechaCitaRad && !solicitudDestino.EsRadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO RAD FUERA DE HORARIO' && solicitudDestino.EsRadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id} >{sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                        )
                                                        }
                                                        {localStorage.getItem("idioma")!=='en-US' && solicitudDestino.serviciosAdicionalesOrigen?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                                solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA RAD' && solicitudDestino.fechaCitaRad && !solicitudDestino.EsRadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO RAD FUERA DE HORARIO' && solicitudDestino.EsRadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id} >{sa.nombre}</li> : null
                                                        )
                                                        }
                                                    </ul>
                                                </td>
                                                {/* <td />

                                                <td style={{ verticalAlign: "top" }}>
                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>

                                                        {solicitudDestino.serviciosAdicionalesOrigen?.map(sa =>

                                                        solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !==3 && sa.seleccionado !== undefined && (sa.nombre == 'FLETE CARGO RAD FUERA DE HORARIO' && solicitudDestino.EsRadCitaFueraHorario) ||  sa.seleccionado ? <li key={sa.id}   >{sa.nombre}</li> : null
                                                        )
                                                        }
                                                    </ul>
                                                </td>         */}
                                            </tr>
                                        </table>
                                    </td>
                                    <td></td>
                                    <td>

                                        <table>

                                            <tr className={classes.additional}>
                                                <td style={{ verticalAlign: "top" }}>
                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                        {solicitud.tipoRecoleccionIdDestino !== undefined
                                                            &&
                                                            solicitud.tipoRecoleccionIdDestino !== 3
                                                            &&
                                                            fechaEad
                                                            &&
                                                            (
                                                                !solicitudDestino.EsEadCitaFueraHorario
                                                                &&
                                                                <li key={0}>{fechaEad.toString().substr(0, 11)}</li>
                                                                ||
                                                                solicitudDestino.EsEadCitaFueraHorario
                                                                &&
                                                                <li>
                                                                    {fechaEad.toString().substr(0, 11) + " " + solicitud.EadCitaHoraDe + " - " + solicitud.EadCitaHoraHasta}
                                                                </li>
                                                            )

                                                        }
                                                        
                                                        {localStorage.getItem("idioma")==='en-US' && solicitudDestino.serviciosAdicionalesDestino?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                                solicitudDestino.tipoRecoleccionIdDestino !== undefined && solicitudDestino.tipoRecoleccionIdDestino !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA EAD' && solicitudDestino.fechaCitaEad && !solicitudDestino.EsEadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO EAD FUERA DE HORARIO' && solicitudDestino.EsEadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                        )
                                                        }
                                                        {localStorage.getItem("idioma")!=='en-US' && solicitudDestino.serviciosAdicionalesDestino?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map(sa =>
                                                                solicitudDestino.tipoRecoleccionIdDestino !== undefined && solicitudDestino.tipoRecoleccionIdDestino !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA EAD' && solicitudDestino.fechaCitaEad && !solicitudDestino.EsEadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO EAD FUERA DE HORARIO' && solicitudDestino.EsEadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.nombre}</li> : null
                                                        )
                                                        }

                                                    </ul>
                                                </td>
                                                {/* <td />
                                                <td style={{ verticalAlign: "top" }}>
                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>

                                                        {solicitudDestino.serviciosAdicionalesDestino?.map(sa =>
                                                            solicitud.tipoRecoleccionIdDestino !== undefined && solicitud.tipoRecoleccionIdDestino !==3 && sa.seleccionado !== undefined && (sa.nombre == 'FLETE CARGO EAD FUERA DE HORARIO' && solicitudDestino.EsEadCitaFueraHorario) ||  sa.seleccionado ? <li key={sa.id}   >{sa.nombre}</li> : null

                                                        )
                                                        }
                                                    </ul>
                                                </td> */}
                                            </tr>

                                        </table>
                                    </td>
                                </tr>
                                


                            </tbody>
                        </table>
                    </Box>

                    <Box display="flex" flexDirection="column">
                        {solicitud.tipoServicio &&
                            <>
                                <Box className={classes.title}>
                                    {/* SERVICIO */
                                        traducirLabel(276)}
                                </Box>
                                <Box className={classes.information}>
                                    {solicitud.tipoServicio?.nombre}
                                </Box>
                            </>
                        }

                        {solicitud.cruceFronterizo &&
                            <>
                                <Box className={classes.title}>
                                    {/* CRUCE */
                                        traducirLabel(345)}
                                </Box>
                                <Box className={classes.information}>
                                    {solicitud.cruceFronterizo?.cruce}
                                </Box>
                            </>
                        }

                        {solicitud.tipoEnvio &&
                            <>
                                <Box className={classes.title}>
                                    {/* ENVÍO */
                                        traducirLabel(122)}
                                </Box>

                                <Box className={classes.information} mb={2}>
                                    {solicitud.tipoEnvio?.nombre}
                                </Box>
                            </>
                        }

                        <Divider light />

                        {(solicitud.serviciosAdicionales || tipoSeguro) &&
                            <>
                                <Box className={classes.title}>
                                    {/* SERVICIOS ADICIONALES */
                                        traducirLabel(278)}
                                </Box>

                                <Box className={classes.information}>
                                    {tipoSeguro}
                                </Box>

                                {localStorage.getItem("idioma") === 'en-US' && solicitud.serviciosAdicionales?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map((sa, index) =>
                                    <Box key={index} className={classes.information}>
                                        {(sa.etiquetaServicioAdicionalDto?.nombre === undefined || sa.etiquetaServicioAdicionalDto?.nombre === '') ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}
                                    </Box>
                                )}

                                {localStorage.getItem("idioma") !== 'en-US' && solicitud.serviciosAdicionales?.filter(sa => !(solicitud.esServicioInternacional && sa.id === enums.servicioAdicional.retornoDocumentos)).map((sa, index) =>
                                    <Box key={index} className={classes.information}>
                                        {sa.nombre}
                                    </Box>
                                )}
                                
                                {/* ESTA SECCION ESTARA COMENTADA HASTA QUE SE DEFINAN EL PROCESO DE MARKUP*/
                                /*solicitud.markupMonto !== undefined &&
                                    <>
                                        <Box className={classes.information} mb={2}>
                                            MARKUP
                                        </Box>
                                    </>
                                */}

                                {/*<Box className={classes.information}>*/}
                                {/*Markup*/}
                                {/*</Box>*/}
                            </>
                        }
                    </Box>
                </Box>
            </Paper>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitudCopia,
    solicitudDestino: state.solicitud,
    cliente: state.cliente
});

export default connect(mapStateToProps)(Resumen);
